<form class="flex w-full flex-col gap-3 p-6 lg:gap-8" [formGroup]="filterForm">
  <div class="flex w-full flex-col gap-4">
    <mat-form-field class="w-full">
      <mat-label>Izvēlieties datuma veidu</mat-label>
      <mat-select [value]="selectedPickerType" (selectionChange)="onPickerTypeChange($event.value)">
        <mat-option value="custom">Pielāgots</mat-option>
        <mat-option value="week">Nedēļa</mat-option>
        <mat-option value="month">Mēnesis</mat-option>
        <mat-option value="quarter">Ceturksnis</mat-option>
        <mat-option value="year">Gads</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="gap 2 flex w-full items-center justify-center">
      @switch (selectedPickerType) {
        @case ("custom") {
          <mat-form-field class="w-full">
            <mat-label>Izvēlieties datumu</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input formControlName="startDate" matStartDate placeholder="Sākuma datums" />
              <input formControlName="endDate" matEndDate placeholder="Beigu datums" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker" />
            <mat-datepicker-toggle matSuffix aria-label="Notīrīt filtru" (click)="clearDate(picker)">
              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker />

            @if (filterForm.controls.startDate.hasError("matStartDateInvalid")) {
              <mat-error>Nepareizs sākuma datums</mat-error>
            }
            @if (filterForm.controls.endDate.hasError("matEndDateInvalid")) {
              <mat-error>Nepareizs beigu datums</mat-error>
            }
          </mat-form-field>
        }

        @case ("week") {
          <norupe-week-picker class="w-full" (endDate)="onEndDateSelected($event)" (startDate)="onStartDateSelected($event)" />
        }

        @case ("month") {
          <norupe-month-picker class="w-full" (endDate)="onEndDateSelected($event)" (startDate)="onStartDateSelected($event)" />
        }

        @case ("quarter") {
          <norupe-quarterly-picker class="w-full" (endDate)="onEndDateSelected($event)" (startDate)="onStartDateSelected($event)" />
        }

        @case ("year") {
          <norupe-year-picker class="w-full" (endDate)="onEndDateSelected($event)" (startDate)="onStartDateSelected($event)" />
        }
      }
    </div>
  </div>

  <mat-form-field class="flex w-full">
    <mat-label>Darbinieki </mat-label>
    <mat-select formControlName="assignedTo" multiple>
      @let employees = employeeStore.entities();
      @defer (when (employees ?? []).length > 0) {
        @for (item of employees; track $index) {
          <mat-option [value]="item.id"> {{ item.first_name + " " + item.last_name }}</mat-option>
        }
      } @loading (after 10ms; minimum 1s) {
        <div role="status">
          <svg
            fill="none"
            viewBox="0 0 100 101"
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
            aria-hidden="true"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="flex w-full">
    <mat-label>Darba veids</mat-label>
    <mat-select formControlName="type" multiple>
      @let resourceTypes = resourceTypeStore.entities();
      @defer (when (resourceTypes ?? []).length > 0) {
        @for (item of resourceTypes; track $index) {
          <mat-option [value]="item.id"> {{ item.name }}</mat-option>
        }
      } @loading (after 10ms; minimum 1s) {
        <div role="status">
          <svg
            fill="none"
            viewBox="0 0 100 101"
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
            aria-hidden="true"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      }
    </mat-select>
  </mat-form-field>
  <button
    matButton
    matStepperNext
    type="button"
    class="inline-flex justify-center rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400"
    (click)="loadOverview()"
  >
    <mat-icon>table_view</mat-icon> Iegūt pārskatu
  </button>
</form>
